"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getParametersWithEmptyValue = void 0;
const getParametersWithEmptyValue = (params) => Object.keys(params).filter((key) => params[key].trim() === '');
exports.getParametersWithEmptyValue = getParametersWithEmptyValue;
